import { useState } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { StyledTable, StyledTrInverted, StyledThUnstyled, StyledTd } from '../styles/table';
import { PDPClothingGroup } from '@/data/types/PdpSizes';

interface Props {
	data: PDPClothingGroup[];
}

enum SizeType {
	CM = 'cm',
	IN = 'in',
}

export const ProductDetailsClothesScenery: React.FC<Props> = ({ data }) => {
	const [currentSize, setCurrentSize] = useState<SizeType>(SizeType.CM);

	const handleChangeSize = (size: SizeType) => () => {
		setCurrentSize(size);
	};

	return (
		<Box
			sx={{
				width: '100%',
				height: '100%',
				display: 'flex',
			}}
		>
			<Box
				sx={{
					overflowY: 'auto',
					flex: 1,
					display: 'flex',
					flexDirection: 'column',
					gap: '20px',
				}}
			>
				{data.map((item) => {
					const includeHips = item.sizes.some(
						(size) =>
							size[currentSize].hips !== undefined &&
							size[currentSize].hips !== null &&
							size[currentSize].hips !== ''
					);

					const includeChest = item.sizes.some(
						(size) =>
							size[currentSize].chest !== undefined &&
							size[currentSize].chest !== null &&
							size[currentSize].chest !== ''
					);

					return (
						<Box>
							<Box
								sx={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									paddingBottom: '10px',
									borderBottom: '1px solid #E5E5E5',
								}}
							>
								<Typography
									sx={{
										color: '#333333',
										fontSize: '16px',
										fontWeight: 700,
									}}
								>
									{item.group}
								</Typography>
								{false ? (
									<Box
										sx={{
											border: '1px solid #D5D5D5',
											fontSize: '15px',
											display: 'grid',
											gridTemplateColumns: '1fr 1fr',
										}}
									>
										<ButtonBase
											sx={{
												padding: '5px',
												color: currentSize === SizeType.CM ? '#000000' : '#767676',
												backgroundColor: currentSize === SizeType.CM ? '#F8F7F7' : 'transparent',
												fontWeight: currentSize === SizeType.CM ? 700 : 400,
												borderRight: '1px solid #D5D5D5',
											}}
											onClick={handleChangeSize(SizeType.CM)}
										>
											{'CM'}
										</ButtonBase>
										<ButtonBase
											sx={{
												padding: '5px',
												color: currentSize === SizeType.IN ? '#000000' : '#767676',
												backgroundColor: currentSize === SizeType.IN ? '#F8F7F7' : 'transparent',
												fontWeight: currentSize === SizeType.IN ? 700 : 400,
											}}
											onClick={handleChangeSize(SizeType.IN)}
										>
											{'IN'}
										</ButtonBase>
									</Box>
								) : null}
							</Box>
							<StyledTable>
								<thead>
									<tr>
										<StyledThUnstyled>{'Talla'}</StyledThUnstyled>
										{includeChest ? <StyledThUnstyled>{'Pecho'}</StyledThUnstyled> : null}
										<StyledThUnstyled>{'Cintura'}</StyledThUnstyled>
										{includeHips ? <StyledThUnstyled>{'Cadera'}</StyledThUnstyled> : null}
									</tr>
								</thead>
								<tbody>
									{item.sizes.map((size) => (
										<StyledTrInverted key={size.size}>
											<StyledTd>{size.size}</StyledTd>
											{includeChest ? <StyledTd>{size[currentSize].chest}</StyledTd> : null}
											<StyledTd>{size[currentSize].waist}</StyledTd>
											{includeHips ? <StyledTd>{size[currentSize].hips}</StyledTd> : null}
										</StyledTrInverted>
									))}
								</tbody>
							</StyledTable>
						</Box>
					);
				})}
			</Box>
		</Box>
	);
};
